import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getLabelClasses = ({ dsf_size }) => {
  const classes = ["text-neutral-400"];
  if (dsf_size === "small" || dsf_size === "smaller") {
    classes.push("dsf-text-xxs", "mb-2");
  } else {
    classes.push("dsf-text-xs", "mb-4");
  }
  return concatClasses(classes);
};
const getMessageClasses = ({ dsf_error, dsf_size }) => {
  const classes = ["dsf-text-xxs"];
  classes.push(dsf_size === "small" || dsf_size === "smaller" ? "mt-2" : "mt-4");
  if (dsf_error) {
    classes.push("text-error-300");
  }
  return concatClasses(classes);
};
export {
  getLabelClasses,
  getMessageClasses
};
